// ─── Accommodation-specific constants ─────────────────────────────────────────
// Keep all magic values here so components stay free of inline literals.

/**
 * Chart colour palette for pie/donut charts.
 * Starts with the app's primary brand green, then uses distinct
 * professional colours that complement the green theme.
 */
export const PIE_COLORS: readonly string[] = [
  '#15803d', // pos-primary (green-700)
  '#0891b2', // cyan-600
  '#7c3aed', // violet-700
  '#d97706', // amber-600
  '#dc2626', // red-600
  '#0d9488', // teal-600
  '#9333ea', // purple-600
  '#b45309', // amber-700
  '#059669', // emerald-600
  '#475569', // slate-600
];

export const DAY_NAMES = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
] as const;

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

/** Maximum days to render in the occupancy chart. */
export const OCCUPANCY_MAX_DAYS = 60;
